import axios from "axios";

// The network Zebra is reached through the ACS Label Printer Helper running on
// this PC (a web page cannot scan the network or talk to a printer itself).
// The printer itself is a site-wide setting, so every PC on site uses the same one.
export const HELPER = "http://127.0.0.1:9191";
// ?v= changes with each release: Cloudflare caches the zip, so a new version needs a new URL
export const HELPER_VERSION = "1.0.1";
export const HELPER_DOWNLOAD = "/downloads/ACSLabelHelper.zip?v=" + HELPER_VERSION;

async function helper(path, body, timeoutMs = 8000) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
        const res = await fetch(HELPER + path, body === undefined ? {signal: ctrl.signal} : {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(body),
            signal: ctrl.signal,
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.ok === false) throw new Error(data.detail || ("Helper error " + res.status));
        return data;
    } finally {
        clearTimeout(t);
    }
}

export async function helperStatus() {
    try {
        return await helper("/status", undefined, 3000);
    } catch (e) {
        return null;  // not installed / not running on this PC
    }
}

export const scanForPrinters = () => helper("/scan", undefined, 60000);
export const testPrint = (ip) => helper("/test", {ip});

export const getSitePrinter = () => axios.get("/api/label-printer").then(r => r.data);
export const setSitePrinter = (p) => axios.post("/api/label-printer", p).then(r => r.data);

function download(zpl, filename) {
    const blob = new Blob([zpl], {type: "application/octet-stream"});
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
}

// Print a label on the site Zebra. Falls back to downloading the .zpl, and says why.
export async function printZpl(zpl, filename) {
    let printer = null;
    try {
        printer = await getSitePrinter();
    } catch (e) { /* treated as not set up */ }
    if (!printer || !printer.ip) {
        download(zpl, filename);
        return {how: "downloaded", reason: "No label printer is set up yet - use Label printer to find it."};
    }
    if (!(await helperStatus())) {
        download(zpl, filename);
        return {how: "downloaded", reason: "The ACS Label Printer Helper isn't running on this PC."};
    }
    try {
        await helper("/print", {ip: printer.ip, zpl}, 20000);
        return {how: "printed", printer};
    } catch (e) {
        download(zpl, filename);
        return {how: "downloaded", reason: "Couldn't reach " + (printer.name || printer.ip) + ": " + e.message};
    }
}
